
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(htmlContent: string): SafeHtml {
    // Bypass Angular's security and trust the HTML content
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }
}
